package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Mind_map_node(
  public val id: String,
  public val map_id: String,
  public val parent_id: String?,
  public val text: String,
  public val color: String?,
  public val source_kind: String?,
  public val source_id: String?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
